export const subscriptionStatusMessageMapper = {
    APROVADA: 'Sua assinatura está ativa',
    PENDENTE: 'Sua assinatura está pendente',
    SUSPENSA: 'Sua assinatura está suspensa de renovação',
    REEMBOLSADA: 'Sua assinatura foi reembolsada',
    CONTESTADA: 'Sua assinatura foi contestada',
    'PRE-AUTORIZADA': 'Pré-Autorizada',
}
